import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import { DefaultButton } from '../../components/Buttons';
import './styles.scss';
import { useLanguage } from '../../context/LanguageContext';

const DefaultSettingsButton = withStyles({
  root: {
    backgroundColor: 'rgb(116, 228, 150)',
    borderColor: 'rgb(116, 228, 150)',
    "&:hover": {
      backgroundColor: "rgb(116, 228, 150)"
    }
  },
})(DefaultButton);

const OpenBidCardButton = withStyles({
  root: {
    backgroundColor: '#009688',
    borderColor: '#009688',
    color: 'white',
    "&:hover": {
      backgroundColor: "#009688"
    }
  },
})(DefaultButton);

  const OpenBidCards = props => {
  const { labels } = useLanguage();
  const cards = labels.cards || {};
  const isOpen = props.isOpen !== undefined ? props.isOpen : true;
  
  return (
    <div>
      <div className="row">
        <div
          className="small-4 columns carBid-DaysWrapler"
          style={{ display: 'none' }}
        >
          <div>{cards.contents?.OPENBID_DAYS_LEFT}</div>
          <div>{props.daysLeft}</div>
        </div>
        <div className="columns carBid-LastWrapler">
          <div>{cards.contents?.OPENBID_LAST_CHANGES}</div>
          <div className='lastModifiedDate'>{props.lastModifiedDate}</div>
        </div>
      </div>
      <div className="CardRow cardBid-buttonWrapler">
        {props.defaultSettingsEdit ? (
          <Link to={'/default-settings'}>
            <DefaultSettingsButton
              className="carBid-button-default-requests"
              size="large"

            >{cards.contents?.OPENBID_EDIT_REQUESTS}</DefaultSettingsButton>
          </Link>
        ) : (
          <Link to={`bid-session/${props.bidSessionId}`}>
            {isOpen ? (
              <OpenBidCardButton
                className="carBid-button"
                size="large"
                >{cards.contents?.OPENBID_EDIT_REQUESTS}</OpenBidCardButton>
            ) : (
              <DefaultButton
                className="carBid-button-grey"
                size="large"
                >{cards.contents?.OPENBID_EDIT_REQUESTS}</DefaultButton>
            )}
          </Link>
        )}
      </div>
    </div>
  );
}

OpenBidCards.propTypes = {
  daysLeft: PropTypes.number.isRequired,
  lastModifiedDate: PropTypes.string.isRequired,
  bidSessionId: PropTypes.number.isRequired,
  defaultSettingsEdit: PropTypes.bool,
  isOpen: PropTypes.bool
};

export default OpenBidCards;
